module.exports = __webpack_public_path__ + "static/media/FieldTripHealthSantaMonica.7e53f5dd.jpg";